import {DatePicker} from 'antd';
import type {Moment} from 'moment';
import momentGenerateConfig from 'rc-picker/lib/generate/moment';
import React from 'react';

const GeneratedPicker = DatePicker.generatePicker<Moment>(momentGenerateConfig);

interface ExtraPickerProps {
  showNow?: boolean;
  pickerValue?: Moment;
  onPickerValueChange?: (value: Moment | undefined) => void;
}

const MomentDatePicker = GeneratedPicker as typeof GeneratedPicker &
  React.ComponentType<
    React.ComponentProps<typeof GeneratedPicker> & ExtraPickerProps
  >;

export default MomentDatePicker;
